import qs from 'qs';
import md5 from 'js-md5';

const LOGIN_PATH = '/adminAuth/auth/v3/login';
const LOGOUT_PATH = '/custom/sso/logout';

// 登陆接口
function login(input, useCaptcha) {
  const params = {
    account: input.account,
    passwd: md5(input.password),
  };
  if (useCaptcha) {
    params.captcha = input.captcha;
    params.captchaID = input.captchaID;
  }
  return this.$reqPost(LOGIN_PATH, qs.stringify(params), {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    } })
    .then(rsp => rsp.data.result);
}


function loginSaaS(input) {
  const params = {
    username: input.account,
    password: input.password,
  };
  return this.$reqPost('/saasAuth/permitauth/api/system/auth/login', params).then(rsp => rsp.data);
}

function logout() {
  return this.$reqGet(LOGOUT_PATH).then(rsp => rsp.data.result);
}

export default {
  login,
  loginSaaS,
  logout,
};



// WEBPACK FOOTER //
// ./src/api/login.js